import axios from "axios";

const stripBearer = (value) =>
  String(value || "")
    .replace(/^Bearer\s+/i, "")
    .trim();

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["x-auth-token"] = token;
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    axios.defaults.headers.common.authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.authorization;
  }
};

export const getDefaultAuthToken = () =>
  stripBearer(
    axios.defaults.headers.common.Authorization ||
      axios.defaults.headers.common.authorization ||
      axios.defaults.headers.common["x-auth-token"] ||
      ""
  ) || null;